import { apiClient } from "../../services/apiService";
import Logger from "../../utils/logger";
import { DeploymentInfo } from "./Index";

// Fetch deployment history from API
export const fetchDeploymentHistory = async (
  repo: string,
  env: string,
  page: number,
  pageSize: number
): Promise<DeploymentInfo[]> => {
  Logger.info("Fetching deployment history", { repo, env, page, pageSize });

  try {
    const { data } = await apiClient.get(
      `/cloudwatch/log-streams/${repo}-${env}?page=${page}&pageSize=${pageSize}`
    );

    Logger.info("Deployment history fetched successfully", { data });

    const tableData: DeploymentInfo[] = data.logEvents.length
      ? data.logEvents.map((item: { message: DeploymentInfo }) => item.message)
      : [];

    Logger.info("Parsed deployment history", { tableData });

    return tableData;
  } catch (error) {
    Logger.error("Failed to fetch deployment history", { error });

    throw new Error("Failed to fetch data");
  }
};
